import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../utils';

// base empty API instance, that will we lazily extended by 'injectEndpoint'
export const baseApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'QUERY',
  endpoints: () => ({}),
});
